// extracted by mini-css-extract-plugin
export default {"card":"SupplierAccountCard_card__fUoKn","container":"SupplierAccountCard_container__F2ju0","content":"SupplierAccountCard_content__+mPgb"};